import { render, staticRenderFns } from "./templateList.vue?vue&type=template&id=ffcc7a5e&scoped=true"
import script from "./templateList.vue?vue&type=script&lang=js"
export * from "./templateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc7a5e",
  null
  
)

export default component.exports